module.exports = __webpack_public_path__ + "static/4_SUPERSINGLE-1de6a36b861852ffae8a7df6a3c9bfa3.png";